import { render, staticRenderFns } from "./SchoolTeacherPage.vue?vue&type=template&id=5707285c&scoped=true&"
import script from "./SchoolTeacherPage.vue?vue&type=script&lang=js&"
export * from "./SchoolTeacherPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707285c",
  null
  
)

export default component.exports